module.exports = __webpack_public_path__ + "static/media/img-banner-favedeals@3x.7a7e34ba.png";